// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:767px){.about-page .rn-skill-right[data-v-08ff0915]{order:2}}.person[data-v-08ff0915]{width:125px}", ""]);
// Exports
module.exports = exports;
